/*! @azure/msal-common v4.5.1 2021-08-02 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "4.5.1";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
